import { useContext } from 'react';

import { FormContainerContext } from '~contexts';

const useFormContainerState = () => {
	const formContainerContext = useContext(FormContainerContext);
	if (formContainerContext === undefined) {
		throw new Error(
			`${FormContainerContext.displayName} must be inside a ${useFormContainerState.name}`
		);
	}

	return formContainerContext;
};

export default useFormContainerState;
